import React, { useContext } from 'react';
import { PopularFacetsFragment } from 'src/types';

import { AppContext } from '@prisjakt/ui-app-context';
import { Panel, PanelHeader, PanelTitle } from '@prisjakt/ui/panel';
import ExpandableGrid from '@prisjakt/ui-expandable-grid';
import MatchMedia from '../../../../components/match-media';
import { ProductGridCard } from '@prisjakt/ui-product-card-new';
import { TitleMediumText, FontColor } from '@prisjakt/ui/text/variants';

import { InternalLink } from '../product-recommendations/styles';

type Props = PopularFacetsFragment['popularFacets'][0];

export const PopularFacetsSection = ({
  title,
  url,
  products,
  linkText,
}: Props) => {
  const { t } = useContext(AppContext);

  return (
    <Panel>
      <PanelHeader style={{ flexWrap: 'wrap' }}>
        <PanelTitle>{title}</PanelTitle>
        <InternalLink to={url}>
          <TitleMediumText color={FontColor.PRIMARY}>
            {linkText}
          </TitleMediumText>
        </InternalLink>
      </PanelHeader>
      <MatchMedia
        debounce={1000}
        serverSideRender={{ tablet: false }}
        matches={[
          {
            mediaQuery: '(min-width: 640px) and (max-width: 1000px)',
            values: { tablet: true },
          },
          {
            mediaQuery: 'all',
            values: { tablet: false },
          },
        ]}
      >
        {({ tablet }: any) => (
          <ExpandableGrid
            limit={tablet ? 3 : 4}
            expandText={t('common', 'button.show-more')}
            collapseText={t('common', 'button.show-less')}
            cssGrid
            items={products.map((product, index) => (
              <ProductGridCard
                key={product.id}
                imageSrc={product.media.first}
                lazyLoadImage
                link={product.pathName}
                name={product.name}
                price={
                  product.priceSummary.regular ||
                  product.priceSummary.alternative
                }
                rating={product.userReviewSummary.rating}
                reviewsCount={product.userReviewSummary.count}
              />
            ))}
          />
        )}
      </MatchMedia>
    </Panel>
  );
};
